<template>
	<scale-box>
		<!-- <dv-full-screen-container class="data-screen"> -->
		<div class="content">
			<div v-if="area.length && area[area.length - 1] != '浙江省'" class="map-title">
				<h1>{{ area[area.length - 1] }}</h1>
			</div>
			<!-- <div style="position: absolute; width: 100%; overflow: hidden"> -->
			<div class="top-layout">
				商标数据驾驶舱
				<!-- <img class="logo-img" src="../assets/2/logo.png" alt="" /> -->
				<!-- <img class="top-img" src="../assets/2/header-bg.png" alt="" /> -->
				<!--/*          <h2 style="position: absolute;margin-left: 50%;top: 30px">当前范围：{{ area[area.length-1] }}</h2>-->
				<!--          <div class="map-title">当前范围：{{ area[area.length-1] }}</div>-->
				<!-- <div v-if="area.length && area[area.length - 1] != '浙江省'" class="map-title">
					<h1>{{ area[area.length - 1] }}</h1>
				</div> -->
			</div>
			<!-- </div> -->
			<Clock style="position: absolute; right: 80px;top: 120px;" class="color"></Clock>
			<!--      left -->
			<div class="tabs">
				<div style="position: absolute; left: 240px;top: 50px;font-size: 20px;font-weight: 400;">
					<div class="active tab" style="margin-right: 40px;">
						商标数据驾驶舱
					</div>
					<div class="tab" @click="goTJ">
						数据统计和应用
					</div>
				</div>
				<div style="position: absolute; right: 240px;top: 50px;font-size: 20px;font-weight: 400;cursor: pointer;">				
					<div class="tab" style="margin-right: 40px;" @click="goZL">
						专利数据驾驶舱
					</div>
					<div class="tab" @click="goTJ">
						数据统计和应用
					</div>
				</div>
			</div>
			<div class="left" style="margin-left: 80px">				
				<div class="left-top-warp">				
					<div class="block-title" @click="goDetail(1)">
						<div>
							<span>商标地区分布</span>
							<span style="margin-left: 30px;color: #FFFFFF;">更多</span>
							<img src="../assets/2/more.png" width="24" height="24" alt="">
						</div>
						<!-- <div class="block-subtitle">Regional Distribution</div>						 -->
					</div>
					<chart :option="leftTop.option" style="height: 360px" @change="leftTopLabelChange" />
					
					<div class="block-title" @click="goDetail(2)">
						<div>
							<span>城市商标排名</span>
							<span style="margin-left: 30px;color: #FFFFFF;">更多</span>
							<img src="../assets/2/more.png" width="24" height="24" alt="">
						</div>
						<!-- <div class="block-subtitle">City Trademark Ranking</div> -->
					</div>
					<chart style="height: 250px" id="leftTopCenter" :option="leftTopBottom.option"
						@change="leftCenterLabelChange" />
					<!-- <div style="
              padding: 0 20px;
              margin-top: 15px;
              margin-bottom: 15px;
              height: 210px;
            ">
						<swiperList2 :year="year" :data="leftTopBottom"></swiperList2>
					</div> -->
				</div>
				<div class="left-bottom-wrap">
					<div class="block-title" @click="goDetail(3)">
						<div>
							<span>拥有商标企业</span>
							<span style="margin-left: 30px;color: #FFFFFF;">更多</span>
							<img src="../assets/2/more.png" width="24" height="24" alt="">
						</div>
						<!-- <div class="block-subtitle">Companies with Trademarks</div> -->
					</div>
					<chart style="height: 300px" class="block" id="leftCenter" :option="leftCenter.option"
						@change="leftCenterLabelChange" />
				</div>
			</div>
			<!--center-->
			<div class="center">
				<div class="center-header" style="z-index: 99">
					<div class="t1">
						<div style="font-size: 14px">商标总量</div>
						<div class="num">
							{{ brandTotal }}
						</div>
					</div>
					<div class="t2">
						<div style="font-size: 14px;">有效注册量</div>
						<div class="num">
							{{ regNum }}
						</div>
					</div>
					<div class="t3">
						<div style="font-size: 14px">{{ year ? '当年申请量' : '历年申请量' }}</div>
						<div class="num">{{ sumApply }}</div>
					</div>
				</div>
				<div class="center-wrap">
					<!--          <div class="center-float"></div>-->
					
					<!--        地图-->
					<chart-map @rightBottom="onUpDataRightBottom" id="map" :year="year" :map-data="map" :city="city" @areaClick="areaClick" @changeMap="changeMap" />
					<div style="position: absolute; right: -110px; top: 30px">
						<div style="
                position: relative;
                overflow: hidden;
                cursor: pointer;
                border: 1px solid rgba(46, 96, 153, 0.5);
                height: 20px;
                line-height: 20px;
                padding: 5px 15px;
                border-radius: 3px;
                margin-right: 180px;
                margin-top: 15px;
                background: rgba(0, 0, 0, 0.5);
              ">
							<div style="color: #fff; font-size: 16px">
								<template v-if="year">{{ year }}年</template>
								<template v-else>全部年份</template>
							</div>
							<el-date-picker
                			style="opacity: 0; position: absolute; top: 0; left: 0"
							v-model="year"
							type="year"
							size="mini"
							format="yyyy"
							value-format="yyyy"
							placeholder="请选择年份"
							:picker-options="pickerOptions"
						>
							<!-- <el-date-picker style="opacity: 0; position: absolute; top: 0; left: 0" v-model="year"
								type="year" size="mini" format="yyyy" value-format="yyyy" placeholder="请选择年份"> -->
							</el-date-picker>
						</div>
					</div>
					<div style="overflow: hidden;display: flex;justify-content: space-evenly;margin-top: 10px;">
						<div style="width: 420px;">
							<div class="block-title2" style="margin-bottom: -20px" @click="goDetail(7)">
								<div style="margin-left: 50px;display: flex;">
									<span>成功率趋势</span>
									<span style="margin-left: 30px;color: #FFFFFF;">更多</span>
									<img src="../assets/2/more.png" width="24" height="24" alt="">
								</div>
								<!-- <div class="block-subtitle">The Success Rate</div> -->
							</div>
							<chart style="height: 280px;width: 100%;" class="block"
								:option="rightBottom.option" />
						</div>
						<div style="width: 420px;">
							<div class="block-title2" style="margin-bottom: -20px" @click="goDetail(8)">
								<div style="margin-left: 50px;display: flex;">
									<span>商标行业排名</span>
									<span style="margin-left: 30px;color: #FFFFFF;">更多</span>
									<img src="../assets/2/more.png" width="24" height="24" alt="">
								</div>
								<!-- <div class="block-subtitle">Industry Ranking</div> -->
							</div>
							<chart style="height: 280px;width: 100%;" class="block" :option="leftBottom.option" />
						</div>					
					</div>
				</div>
			</div>
			<!--      right-->
			<div class="right">
				<div class="right-top-wrap">
					<div class="block-title" @click="goDetail(4)">
						<div>
							<span>商标类别排行</span>
							<span style="margin-left: 30px;color: #FFFFFF;">更多</span>
							<img src="../assets/2/more.png" width="24" height="24" alt="">
						</div>
						<!-- <div class="block-subtitle">Trademark Category Ranking</div> -->
					</div>
					<chart style="height: 340px; width: 100%" class="block" id="rightCenter"
						:option="rightCenter.option" />
					<div class="block-title" @click="goDetail(5)">
						<div>
							<span>产品/服务分布</span>
							<span style="margin-left: 30px;color: #FFFFFF;">更多</span>
							<img src="../assets/2/more.png" width="24" height="24" alt="">
						</div>
						<!-- <div class="block-subtitle">Product Distribution</div> -->
					</div>
					<div style="height: 300px; width: 100%">
						<chart :option="rightTop.option" />
					</div>
				</div>
				<div class="right-bottom-wrap">
					<div class="block-title" @click="goDetail(6)">
						<div>
							<span>申请量TOP10</span>
							<span style="margin-left: 30px;color: #FFFFFF;">更多</span>
							<img src="../assets/2/more.png" width="24" height="24" alt="">
						</div>
						<!-- <div class="block-subtitle">Registration Ranking</div> -->
					</div>
					<SwiperList style="margin-top: 20px;" :year="year" :data="companyData"></SwiperList>
					<!--            <div v-for="(item,index) in companyData"-->
					<!--                 style="display:flex;justify-content: space-between; font-size:14px;padding:5px 0">-->
					<!--              <div>{{ index + 1 }}</div>-->
					<!--              <div style="width:180px;">{{ item.name }}</div>-->
					<!--              <div>{{ item.value }}</div>-->
					<!--            </div>-->
				</div>
			</div>
			<!-- <div class="footer">版权所有<i>2022</i>&copy;果老网</div> -->
		</div>

		<!-- </dv-full-screen-container> -->
	</scale-box>
</template>

<script>
	import cityData from "../api/city.json";
	import Chart from "../components/chart.vue";
	import ChartMap from "../components/chart-map.vue";
	import CountUp from "vue-countup-v2";
	import {
		getChartOption
	} from "../libs/chart_options";
	import { Arg } from "@/libs/arg.js"
	import {
		getData
	} from "../test";
	import SwiperList from "../components/swiper-list";
	import swiperList2 from "../components/swiper-list2";
	import scaleBox from "../components/sclae-box";
	import {
		centerData,
		getTrademarkTendencyChart,
		leftBottomData,
		leftCenterData,
		leftTopData,
		leftTopData1,
		rightCenterData,
		rightTopBottomData,
	} from "../api/dataView";
	import Clock from "../components/clock";
	import Cookie from "js-cookie";
	import moment from "moment";	
	import {
		getUserInfoByTokenInfo
	} from "../api/user";

	export default {
		name: "dataScreenView",
		data() {
			return {
				loading: false,
				leftTop: {
					option: {},
					labels: {},
				},
				leftCenter: {
					option: {},
					labels: {},
				},
				leftTopBottom: {
					option: {},
					labels: {},
				},
				leftBottom: {
					option: {},
				},
				rightTop: {
					option: {},
				},
				rightCenter: {
					option: {},
				},
				rightBottom: {
					option: {},
				},
				centerCenter: {
					option: {},
				},
				centerTopLeft: {
					option: {},
				},
				centerTopCenter: {},
				centerTopRight: {},
				log: "",
				map: [],
				companyData: [],
				// year: String(moment().year()),
				year: "2023",
				area: [],
				queryParams: {
					// applyYear: String(moment().year()),
					applyYear: "2023",
					level: "1",
					province: "",
					city: "",
					county: "",
				},
				sumApply: "",
				brandTotal: "",
				regNum: "",
				zhixiashi: ["北京市", "上海市", "天津市", "重庆市"],
				pickerOptions: {
					shortcuts: [{
						text: "全部年份",
						onClick(picker) {
							// console.log(picker)
							picker.$emit("pick", "");
						},
					}, ],
				},
				rightTopTimer: null,
				rightTopIndex: 0,
				rcData: [],
				city: {}
			};
		},
		created() {
			const code = this.$route.query.code1 || '210000'
			this.city = {
              name: cityData[code],
              code: code,
            }
		},
		computed: {
			level: function() {
				return this.area.length;
			},
		},
		methods: {
			leftTopLabelChange(value) {
				this.leftTop.option = getChartOption(
					"leftTop",
					getData("leftTop", value)
				);
			},
			leftCenterLabelChange(value) {
				this.leftCenter.option = getChartOption(
					"leftCenter",
					getData("leftCenter", value)
				);
			},
			changeMap(e) {
				this.area = e;
				Arg.queryParams.area = e
				// console.log(this.area)
				let len = e.length;
				// console.log(len)
				// console.log(e)
				this.queryParams.level = len + 1 + "";			
				switch (len) {
					case 0:
						this.queryParams.province = "";
						this.queryParams.city = "";
						this.queryParams.level = "1";
						break;
					case 1:
						this.queryParams.province = e[0];
						this.queryParams.city = "";
						if (this.zhixiashi.includes(e[0])) {
							this.queryParams.city = e[0];
							this.queryParams.level = "3";
						}
						break;
					case 2:
						this.queryParams.province = e[0];
						this.queryParams.city = e[1];
						this.queryParams.county = e[2];
						this.queryParams.level = "3";
						// console.log(this.queryParams)
						// if (this.zhixiashi.includes(e[0])&&e[0]!=='china') {
						//   return;
						// }
						break;
					case 3:
						// 区域更新地图 不更新数据
						// this.queryParams.province = e[0];
						// this.queryParams.city = e[1];
						// this.queryParams.county = e[2];
						// this.queryParams.level = "4";
						// return;
						break;
				}
				Arg.queryParams = this.queryParams
				this.changeHandle();
			},
			areaClick(name, crumb) {
				if (this.zhixiashi.includes(crumb[0])) return;
				// console.log("areaClick");
				// console.log(name, crumb);
				let [province, city] = crumb;
				let county = name;
				this.queryParams.province = province;
				this.queryParams.city = city;
				this.queryParams.county = county;
				if (this.zhixiashi.includes(province)) {
					this.queryParams.city = province;
					// return
				}
				this.queryParams.level = "4";
				Arg.queryParams = this.queryParams
				this.loading = true;
				Promise.all([
						this.getLeftBottom(),
						// this.getRightTop(),
						this.getRightCenter(),
						this.getRightTopBottom(),
					])
					.then((values) => {
						this.loading = false;
						let [leftBottom, rightCenter, rightTopBottom] = values;
						//leftBottom
						this.leftBottom.option.series.data = Object.values(leftBottom);
						this.leftBottom.option.xAxis.data = Object.keys(leftBottom);

						//rightTop
						// this.rightTop.option.series.data = Object.values(rightTop)
						// this.rightTop.option.yAxis.data = Object.keys(rightTop)
						// console.log(rightTop);

						//rightTopBottom
						this.companyData = rightTopBottom;

						//rightCenter
						this.rightCenter.option.series.data = Object.values(rightCenter);
						this.rightCenter.option.xAxis.data = Object.keys(rightCenter);
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			changeHandle() {
				this.loading = true;
				Promise.all([
						this.getLeftTop(),
						this.getLeftTop1(),
						this.getLeftCenter(),
						this.getLeftBottom(),
						// this.getRightTop(),
						this.getRightCenter(),
						this.getRightTopBottom(),
						this.getCenterData(),
						this.getRightBottomData(),
						this.getCenterTopData(),
					])
					.then((values) => {
						this.loading = false;
						let [
							leftTop,
							leftTop1,
							leftCenter,
							leftBottom,
							rightCenter,
							rightTopBottom,
							centerData,
							rightBottom,
						] = values;

						//  直辖市和三级地图展开时候
						if (this.zhixiashi.includes(this.area[0]) && this.area.length > 1)
							return;
						// 下面数据加载以及时间选择器不够严谨 容易导致地图错误 无法再次更新
						this.map = centerData;
						
						//leftTop
						this.leftTop.option = getChartOption("leftTop", {
							yData: leftTop1,
						});
						
						// leftTopBottom
						leftTop = leftTop.sort((a, b) => b.value - a.value);
						this.leftTopBottom.option = getChartOption("leftTopBottom", {
							// xData: Object.keys(leftTop).filter((item, index) => index < 5),
							yData: Object.values(leftTop).filter((item, index) => index < 5),
						});
						// this.leftTopBottom = leftTop;
						// console.log(this.leftTopBottom,2222)
			
						//  leftCenter
						this.leftCenter.option = getChartOption("leftCenter", {
							xData: Object.keys(leftCenter).filter((item, index) => index < 5),
							yData: Object.values(leftCenter).filter((item, index) => index < 5),
						});

						//leftBottom		
						// console.log(leftBottom);
						let leftBottomData = []
						for (let key in leftBottom) {
							leftBottomData.push({
								name: key,
								value: leftBottom[key]
							})
						}
						// console.log(leftBottomData);
						leftBottomData = leftBottomData.splice(0,5)
						this.leftBottom.option = getChartOption("leftBottom", {
							// xData: Object.keys(leftBottom),
							// yData: Object.values(leftBottom),
							yData: leftBottomData
						});

						//rightTop
						// this.rightTop.option = getChartOption('rightTop', {
						//   xData: Object.keys(rightTop),
						//   yData: Object.values(rightTop)
						// })

						//rightTopBottom
						this.companyData = rightTopBottom;
						//rightCenter
						this.rightCenter.option = getChartOption("rightCenter", {
							xData: Object.keys(rightCenter),
							yData: Object.values(rightCenter),
						});
						
						// console.log(this.rcData)
						let rcData = this.rcData[0].tmdetail.split(';')
						let dataRT = []
						rcData.forEach((item, index) => {
							let cnt = item.slice(0, item.indexOf(':'))
							let detail = item.slice(item.indexOf(':') + 1)
							dataRT[index] = {
								value: detail,
								name: cnt
							}
						})
						dataRT = dataRT.sort((a, b) => a.value - b.value)
							.splice(0, 5);
						let rightTopData = dataRT.map(i => {
							i.value = i.value
							i.name = i.name
							return i
						})
						this.rightTop.option = getChartOption("rightTop", {
							xData: rcData.map((i) => i.detail),
							yData: rightTopData,
							// yData: rcData.map((i) => i.cnt),
						});
						//centerData

						// console.log(centerData);

						//rightBottom
						rightBottom = rightBottom.splice(0, 5)
						this.rightBottom.option = getChartOption("rightBottom", {
							xData: rightBottom.map((i) => i.applyYear),
							yData: [
								rightBottom.map((i) => i.sumApply - 0),
								rightBottom.map((i) => i.sumValid - 0),
								rightBottom.map((i) =>
									((i.sumValid / i.sumApply) * 100).toFixed(2)
								),
							],
						});
						this.rightBottom.option.series[0].data = rightBottom.map(
							(i) => i.sumApply
						);
						this.rightBottom.option.series[1].data = rightBottom.map(
							(i) => i.sumValid
						);
						this.rightBottom.option.series[2].data = rightBottom.map((i) =>
							((i.sumValid / i.sumApply) * 100).toFixed(2)
						);
						// console.log(centerData)
						if(this.area.length == 3){
							this.onUpDataRightBottom(this.area[2]);
							// this.updatagetRightCenter()
						}
						if(this.year == ""){
					      this.sumApply = this.brandTotal;
						}
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			//商标地区分布top5+其他
			async getLeftTop() {
				let res = await leftTopData1((this.getQueryParams(this.queryParams)));
        // console.log(res.data.data,1111)
				let props = {
					0: "province",
					1: "city",
					2: "county"
				};
				let level = this.area.length;
				if (this.zhixiashi.includes(this.queryParams.province)) {
					this.queryParams.city = this.queryParams.province;
					level = 2;
					this.queryParams.level = "3";
				} else {
					this.queryParams.level = level + 1;
				}
				Arg.queryParams = this.queryParams
				if (level == 4) level = 3;
				if (res.data.data) {
					return res.data.data
						.map((i) => {

							// let name = i[props[level]];
							return {
								name:i.county,
								value: i.applyCnt,
							};
						})
						.filter((i) => i.name !== "其他");
				}
				return [];
			},
			async getLeftTop1() {
				let res = await leftTopData((this.getQueryParams(this.queryParams)));
				let props = {
					0: "province",
					1: "city",
					2: "county",
				};
				let level = this.area.length;
				if (this.zhixiashi.includes(this.queryParams.province)) {
					this.queryParams.city = this.queryParams.province;
					level = 2;
					this.queryParams.level = "3";
				} else {
					this.queryParams.level = level + 1;
				}
				Arg.queryParams = this.queryParams
				if (level == 4) level = 3;
				if (res.data.data) {
					return res.data.data.map((i) => {
						// let name = i[props[level]];
						return {
							name:i.county,
							value: i.applyCnt,
						};
					});
				}
				return [];
			},

			//商标地区分布top5+其他
			async getLeftCenter() {
				let res = await leftCenterData((this.getQueryParams(this.queryParams)));
				let props = {
					0: "province",
					1: "city",
					2: "county",
					3: "county",
				};
				let level = this.area.length;
				if (this.zhixiashi.includes(this.queryParams.province)) {
					this.queryParams.city = this.queryParams.province;
					level = 2;
					this.queryParams.level = "3";
				} else {
					this.queryParams.level = level + 1;
				}
				Arg.queryParams = this.queryParams
				if (level == 4) level = 3;
				if (res.data.data) {
					let result = {};
					
					res.data.data.forEach((i) => {
						if (i[props[level]] !== "其他") {
							result[i[props[2]]] = i["tmapplicantCnt"];
						}
						// console.log(result)
					});
					
					return result;
				}
				return {};
			},

			async getLeftBottom() {
				var res;
				if(this.area.length == 3){
					this.queryParams.county = this.area[2];
						this.queryParams.level = "4";
					 res = await leftBottomData((this.queryParams));
				}else{
					res= await leftBottomData((this.getQueryParams(this.queryParams)));
				}
				Arg.queryParams = this.queryParams
				if (res.data.data) {
					let result = {};
					res.data.data.forEach((i) => {
						result[i["industry"]] = i["applyCnt"];
					});
					return result;
				}
				return {};
			},
			// async getRightTop() {
			//   let res = await rightTopData(this.queryParams);
			//   if (res.data.data) {
			//     let result = {};
			//     let arr = res.data.data.sort((a, b) => b.rank - a.rank);
			//     arr.forEach((i, index) => {
			//       result[i['tmdetail']] = index + 1
			//     })
			//     return result
			//   }
			//   return {}
			// },
			async getRightCenter() {
				var res;
				if(this.area.length == 3){
					this.queryParams.county = this.area[2];
						this.queryParams.level = "4";
					 res = await rightCenterData((this.queryParams));
				}else{
					 res = await rightCenterData((this.getQueryParams(this.queryParams)));
				}
				Arg.queryParams = this.queryParams
				if (res.data.data) {
					let result = {};
					let arr = res.data.data;

					arr = arr.sort((a, b) => Number(a.rankIntcls) - Number(b.rankIntcls));
					arr = arr.splice(0, 5);
					this.rcData = arr;
					arr.forEach((i) => {
						let key = i["intcls"] + "类" + i["categoryName"];
						result[key] = i["applyCnt"];
					});
					return result;
				}
				return {};
			},
			// updatagetRightCenter(){
			// 	this.getRightCenter()
			// },
			async getRightTopBottom(name = "") {
				// 数据根据 区域变化 通过子组件过来 onUpDataRightBottom => name 不为空
				// console.log(name,123)
				let res = await rightTopBottomData({
					...this.getQueryParams(this.queryParams),
					county: name,
					level: name ? 4 : 3
				});
				if (res.data.data) {
					return res.data.data.map((i) => {
						return {
							name: i.tmapplicant,
							value: i.applyCnt,
						};
					});
				}
				return {};
			},

			onUpDataRightBottom(name) {
				// console.log(name,123)
				this.getRightTopBottom(name).then(res => {
					// this.companyData = []
					this.companyData = res
					//  console.log(this.companyData,123)
				})
			},



			async getCenterData() {
				// return
				let res = await centerData((this.getQueryParams(this.queryParams)));
				let level = this.area.length;
				let props = {
					0: "province",
					1: "city",
					2: "county",
					3: "county",
				};
				if (this.zhixiashi.includes(this.queryParams.province)) {
					this.queryParams.city = this.queryParams.province;
					level = 2;
					this.queryParams.level = "3";
				} else {
					this.queryParams.level = level + 1;
				}
				Arg.queryParams = this.queryParams
				if (level == 4) level = 3
				if (res.data.data[0]) {
					let _data = [];
					switch (level) {
						case 0:
							_data = res.data.data;
							break;
						case 1:
							_data = res.data.data;
							break;
						case 2:
							_data = res.data.data;
							break;
						case 3:
							_data = res.data.data;
							break;
					}
					// console.log(_data)
					return _data.map((i) => {
						return {
							name: i[props[level]],
							value: i.sumApply - 0,
							rank: i.rank,
							sumValid: i.sumValid,
						};
					});
				}
				return {};
			},
			async getCenterTopData() {
				// this.queryParams.type = 0
				let params = {
					...(this.getQueryParams(this.queryParams)),
				};
				params.applyYear = "";
				let res = await getTrademarkTendencyChart(params);
				if (res.data.data) {
					let {
						sumApply,
						sumValid
					} = res.data.data[0];
					this.brandTotal = sumApply;
					this.regNum = sumValid;
				}
			},
			getQueryParams(value) {
				if (value.level == 4) {
					value.level = 3
				}
				return value
			},
			async getRightBottomData() {
				
				let params = {
					...(this.getQueryParams(this.queryParams)),
				};
				// if (this.queryParams.applyYear === "")
				// 	params.applyYear = moment().format("YYYY");
				// if(this.queryParams.applyYear === moment().format('YYYY')) params.applyYear = moment().format('YYYY') - 1;
				var res;
				if(this.area.length == 3){
					params.county = this.area[2];
						params.level = "4";
						if (params.applyYear === "")
						params.applyYear = "2023"
					 res = await getTrademarkTendencyChart(params);
				}else{
					if (params.applyYear === "")
							params.applyYear = "2023"
					res= await getTrademarkTendencyChart((this.getQueryParams(params)));
				}
			// res = await getTrademarkTendencyChart(params);
				if (res.data.data) {
					this.sumApply = res.data.data[0].sumApply;
					// console.log(res.data.data[0].sumApply)
					return res.data.data;
				}
			},
			
			goDetail(type) {
				this.$router.push({
					path: '/dataScreenView/detail',
					query: {
						type: type
					}
				})
			},
			
			findKeyByValue(value) {
				const result = Object.entries(cityData).find(([key, val]) => val === value)
				return result ? result[0] : null
			},
			
			goZL() {
				const code1 = this.findKeyByValue(this.queryParams.province)
				const code2 = this.findKeyByValue(this.queryParams.city)				
				window.location.href = 'https://bgc.guolaoai.com/#/?code1=' + code1 + '&code2=' + code2
			},
			
			goTJ() {
				window.location.href = 'https://tjyy.guolaoai.com'
			},

			initRightTopSwiper() {
				clearInterval(this.rightTopTimer);
				this.rightTopTimer = setInterval(() => {
					if (this.rightTopIndex > 3) {
						this.rightTopIndex = 0;
					} else {
						this.rightTopIndex = this.rightTopIndex + 1;
					}
					let arr = [...this.rightCenter.option.series.data].map((i) => {
						if (typeof i === "object") {
							return i.value;
						}
						return i;
					});
					if (typeof arr[this.rightTopIndex] === "string") {
						arr[this.rightTopIndex] = {
							value: arr[this.rightTopIndex],
							itemStyle: {
								borderColor: "#48A1ED",
								borderWidth: 8,
								borderType: "solid",
								color: "#48A1ED",
							},
						};
					}

					this.rightCenter.option.series.data = arr;
				}, 5000);
			},
		},
		watch: {
			year(e) {
				// console.log(e);
				// console.log(this.year)
				this.queryParams.applyYear = e;
				Arg.queryParams = this.queryParams
				console.log(Arg)
				this.changeHandle();
			},
			rightTopIndex(e) {
				// 直接错误处理 在三级地图时候 有找不到details逻辑错误
				try {
					let rcData = [...this.rcData[e].tmdetail.split(';')];
					let dataRT = []
					rcData.forEach((item, index) => {
						let cnt = item.slice(0, item.indexOf(':'))
						let detail = item.slice(item.indexOf(':') + 1)
						dataRT[index] = {
							value: detail,
							name: cnt
						}
					})						
					dataRT = dataRT.sort((a, b) => a.value - b.value)
						.splice(0, 5);
					let rightTopData = dataRT.map(i => {
						i.value = i.value
						i.name = i.name
						return i
					})
					this.rightTop.option = getChartOption("rightTop", {
						xData: dataRT.map((i) => i.detail),
						yData: rightTopData,
					});
				} catch (e) {}
			},
		},
		mounted() {
			this.initRightTopSwiper();
		},
		destroyed() {
			clearInterval(this.rightTopTimer);
		},
		filters: {
			countUpOption: function(value) {
				return {
					useEasing: true,
					useGrouping: false,
					prefix: "00000".slice((value + "").length),
				};
			},
		},
		components: {
			Clock,
			Chart,
			ChartMap,
			scaleBox,
			CountUp,
			SwiperList,
			swiperList2,
		},
	};
</script>
<style lang="less">
	* {
		margin: 0;
		padding: 0;
	}
	
	body {
		background: #080b1c;
		// background: #000000;
		// background: #ff0000;
	}
</style>
<style lang="less" scoped>
	.header {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		// background-color: #02234d;
		font-size: 24px;
	}
	
	.color {
		color: #18F8FF;
	}

	.content {
		// width: 1920px;
		width: 100%;
		// width: 100%;
		// height: 1080px;
		// background: #ff0000;
		// width: 100%;
		height: 100%;
		display: flex;
		flex-direction: row;
		box-sizing: border-box;
		background-image: url(../assets/2/bg3.png);
		background-repeat: no-repeat;
		background-color: #001D66;
		margin: 0;
		color: #fff;
		position: relative;

		.top-layout {
			position: absolute;
			width: auto;
			height: 120px;
			line-height: 130px;
			left: 10px;
			right: 10px;
			top: 0;
			overflow: hidden;
			text-align: center;
			font-size: 64px;
			font-weight: 600;
			color: #FFFFFF;
			-webkit-background-clip: text;
			font-family: YouSheBiaoTiHei-Regular, YouSheBiaoTiHei;

			.logo-img {
				position: absolute;
				left: 0px;
				top: 0px;
				width: auto;
				height: auto;
			}

			.top-img {
				position: absolute;
				top: 0;
				left: 50%;
				width: auto;
				height: auto;
				transform: translateX(-50%);
				z-index: 0;
			}
		}

		.block {
			box-sizing: border-box;
			padding: 10px;
		}

		.left,
		.right {
			display: flex;
			flex-direction: column;

			.block {
				// width: 300px;
				// height: 300px;
			}
		}

		.right {
			margin-right: 80px;
			.block {
				width: 350px;
			}
		}

		.center {
			flex: 1;
			width: 100%;
			overflow: hidden;
			position: relative;
			flex-wrap: wrap;
		}

		.map-title {
			position: absolute;
			position: absolute; 
			left: 100px;
			top: 120px;
			bottom: 0px;
			color: #ffffff;		
			text-align: center;
			h1 {
				font-weight: bold;
				font-size: 48px;
			}			
		}

		#centerCenter {
			width: 1080px;
			height: 230px;
		}

		#centerTopLeft {
			width: 250px;
			height: 170px;
		}

		#centerTopCenter {
			width: 330px;
			height: 170px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			:nth-child(1) {
				color: #ffff00;
			}

			:nth-child(2) {
				color: #ffa500;
			}

			:nth-child(3) {
				color: #ff0000;
			}

			.block {
				width: 100%;
				height: 50px;
				display: flex;
				align-items: center;
				font-size: 14px;
			}

			.count-up {
				width: 160px;
				margin: 0 8px;
				padding: 0 8px;
				display: block;
				font-size: 18px;
				font-weight: bold;
				line-height: 32px;
				letter-spacing: 25px;
				background: linear-gradient(to right,
						rgba(3, 61, 119, 0.8) 70%,
						rgba(0, 0, 0, 0) 0);
				background-size: 36px;
			}
		}

		#centerTopRight {
			width: 460px;
			height: 170px;
			display: flex;
			flex-wrap: wrap;
			align-items: center;

			.data-item {
				width: 50%;
				font-size: 14px;
			}
		}

		#map {
			margin-top: 30px;
			width: 100%;
			height: 660px;
			// background-image: url(../assets/2/center-bg.png);
			background-size: 700px 463px;
			background-repeat: no-repeat;
			background-position: bottom;
		}

		#mapLeftBottom {
			width: 150px;
			position: absolute;
			bottom: 250px;

			.table {
				width: 100%;
				border-collapse: collapse;

				tr {
					height: 30px;
					border-bottom: 1px dashed #fff;
					font-size: 14px;

					:nth-child(1) {
						color: #fff;
						text-align: left;
					}

					:nth-child(2) {
						color: #fb3;
						text-align: right;
					}
				}
			}
		}
	}

	.footer {
		width: 100%;
		//background: red;
		height: auto;
		display: flex;
		//z-index: 0;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		opacity: 0.5;
		position: absolute;
		bottom: 0px;
		color: #ffffff;
	}

	.center-header {
		display: flex;
		width: 828px;
		background-image: url(../assets/2/center1.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		height: 56px;
		margin: 163px auto 0 auto;
		// top: 0;
		justify-content: space-around;

		&>div {
			text-align: left;
		}
	}

	#leftTop,
	#rightTop {
		height: 550px;
		margin-top: 100px;
	}

	.num {
		font-weight: bold;
		font-size: 26px;
		color: #BAE0FF;
		margin-top: 8px;
	}

	.left-bottom-wrap,
	.left-top-warp,
	.right-top-wrap,
	.center-wrap,
	.right-bottom-wrap,
	.center-float {
		box-sizing: border-box;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.left-top-warp {
		margin-top: 185px;
		// padding-left: 20px;
		// padding-right: 50px;
		// background-image: url(../assets/2/left-top-bg.png);
	}

	.left-bottom-wrap {
		// padding-left: 20px;
		// background-image: url(../assets/2/left-bottom.png);
	}

	.right-top-wrap {
		margin-top: 185px;
		// padding-top: 30px;
		// background-image: url(../assets/right-top.png);
	}

	.right-bottom-wrap {
		height: 350px;
		// background-image: url(../assets/right-bottom.png);
	}

	.center-wrap {
		height: 950px;
		// margin-top: 250px;		
		position: relative;
	}

	//.center-float {
	//  position: absolute;
	//  left: 30px;
	//  top: 110px;
	//  height: 122px;
	//  width: 217px;
	//  background-image: url(../assets/center-float.png);
	//}
	.block-title {
		font-size: 18px;
		font-weight: bold;
		margin-top: 10px;
		color: #ffffff;
		background-image: url(../assets/2/title.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		height: 48px;
		width: 445px;
		padding-left: 50px;
		cursor: pointer;
	}
	
	.block-title>div {
		display: flex;
	}
	
	.block-title>div img {
		margin-left: 8px;
	}
	
	.block-title2 {
		font-size: 18px;
		font-weight: bold;
		margin-top: 10px;
		color: #ffffff;
		background-image: url(../assets/2/title.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		height: 48px;
		cursor: pointer;
	}
	
	.block-title2>div img {
		margin-left: 8px;
	}
	
	.block-title2 .block-subtitle {
		color: #bdbdbd;
		font-weight: normal;
		font-size: 16px;	
		background-image: url(../assets/2/title2.png);
		background-size: 100% 100%;
		height: 48px;
		line-height: 48px;
		background-repeat: no-repeat;
		padding-left: 50px;
	}

	.block-title .block-subtitle {
		color: #bdbdbd;
		font-weight: normal;
		font-size: 16px;	
		margin-top: 6px;
	}

	.t1,
	.t2,
	.t3 {
		background-size: 40px 40px;
		background-repeat: no-repeat;
		background-position-y: 5px;
		padding-left: 20px;
	}
	
	.tabs {
		.tab {
			background-image: url(../assets/2/unselected.png);
			background-size: 100% 100%;
			background-repeat: no-repeat;
			width: 180px;
			height: 50px;
			line-height: 50px;
			display: inline-block;
			font-size: 20px;
			font-weight: 400;
			color: #BAE0FF;
			text-align: center;
			cursor: pointer;
		}
		
		.tab.active {
			background-image: url(../assets/2/selected.png);
			color: #FFFFFF;
		}
		
		.tab:hover {
			background-image: url(../assets/2/selected.png);
			color: #FFFFFF;
		}
		
		.tab:active {
			background-image: url(../assets/2/selected.png);
			color: #FFFFFF;
		}
	}

	// .t1 {
	// 	background-image: url(../assets/icon-1.png);
	// }

	// .t2 {
	// 	background-image: url(../assets/icon-2.png);
	// }

	// .t3 {
	// 	background-image: url(../assets/icon-3.png);
	// 	box-sizing: border-box;
	// }
</style>
